<template>
    <div>
        <!-- <vue-recaptcha sitekey="6LfqWdYZAAAAAK3ePZCKGddm2HEWGhSN1UuPhPsl"></vue-recaptcha> -->
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">

                            Newsletter
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">


                <div class="row">
                    <div class="col-lg-6">

                        <div v-if="guest">
                            <b-form @submit.stop.prevent="onSubmit">
                                <div class="mb-4">
                                    <div class="checkbox-box mb-2" v-for="item in available" v-bind:key="item.id">
                                        <b-form-checkbox v-model="subscriptionsIds2" :value="item.id" name="check-button"
                                            switch>
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </div>

                                    <div class="checkbox-box mb-2" v-for="item in unavailable" v-bind:key="item.id">
                                        <div class="d-inline-block"
                                            v-b-popover.hover.topright="{ variant: 'dark', content: 'Само за пријављене кориснике!' }">
                                            <b-form-checkbox disabled v-model="categoryIds[item.id]" name="check-button"
                                                switch>
                                                {{ item.name }}
                                            </b-form-checkbox>
                                        </div>
                                    </div>

                                </div>
                                <b-input-group>
                                    <b-form-input type="email" :class="{ 'is-invalid form-group--error': $v.email.$error }"
                                        v-model.trim="$v.email.$model" placeholder="Email"></b-form-input>
                                    <b-input-group-append>
                                        <!-- <vue-recaptcha 
                                        sitekey="6LeGXNYZAAAAAJwv-Mrm3idQTv3MN7jgzpHsty1M" 
                                        :loadRecaptchaScript="true"
                                         @verify="onVerify"
                                         @expired="onCaptchaExpired"
                                         ref="recaptcha"
                                        >
                                    </vue-recaptcha> -->
                                        <b-button :disabled="isSubscribed || checkerCaptcha" type="submit"
                                            class="btn-primary-1" variant="primary">Пријава
                                        </b-button>

                                    </b-input-group-append>

                                </b-input-group>
                                <vue-recaptcha sitekey="6Les_iQoAAAAAFw9HlPGxgxLApXSBvbLsUF_EfTx"
                                    :loadRecaptchaScript="true" @verify="onVerify" @expired="onCaptchaExpired"
                                    ref="recaptcha">
                                </vue-recaptcha>
                                <div v-if="$v.email.$dirty">
                                    <div class="form-error " v-if="!$v.email.required">Емаил адреса је обавезна</div>
                                    <div class="form-error " v-if="!$v.email.email">Унесите емаил адресу у исправним
                                        формату
                                    </div>
                                </div>
                            </b-form>
                            <div v-if="subscribeMessage" class="pt-3">
                                <b-alert show fade>{{ subscribeMessage }}</b-alert>
                            </div>

                        </div>
                        <div v-else>

                            <div class="form-group">
                                <div class="checkbox-box mb-2" v-for="item in available" v-bind:key="item.id">
                                    <b-form-checkbox @change="selectOption(item.id)" v-model="subscriptionsIds"
                                        :value="item.id" name="check-button" switch>
                                        {{ item.name }}
                                    </b-form-checkbox>
                                </div>
                                <div class="checkbox-box mb-2" v-for="item in unavailable" v-bind:key="item.id">
                                    <div class="d-inline-block"
                                        v-b-popover.hover.topright="{ variant: 'dark', content: 'Само за пријављене кориснике!' }">
                                        <b-form-checkbox disabled v-model="categoryIds[item.id]" name="check-button" switch>

                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                            <p class="small text-muted">
                                * Newsletter ће се слати на емаил адресу која је дефинисана у Вашем корисничком налогу
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { required, email } from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';


export default {
    name: "NewsletterPage",
    components: { VueRecaptcha },
    data() {
        return {
            recaptcha: null,
            isSubscribed: false,
            subscribeMessage: null,
            categoryIds: [],
            subscriptionsIds: [],
            subscriptionsIds2: [],
            available: null,
            subscriptions: null,
            unavailable: null,
            guest: null,
            email: null,
            checkerCaptcha: true,
            baseApiUrl: window.env.VUE_APP_API_NEWSLETTER_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    validations: {
        email: {
            required,
            email,

        }
    },
    methods: {
        onVerify(response) {
            this.recaptcha = response;
            if (this.recaptcha) {
                this.checkerCaptcha = false;
            }
        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
        },
        onSubmit(evt) {
            evt.preventDefault();

            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
                // do your submit logic here
                axios.post(this.baseApiUrl + 'Prins/SubscribeGuest', {
                    email: this.email,
                    categoryIds: this.subscriptionsIds2,


                }).then(response => {

                    // this.searchResult = response.data;
                    // this.values = response.data.result;
                    this.subscribeMessage = response.data.message;
                    if (response.data.status === 0) {
                        this.isSubscribed = true;
                    }

                    // {
                    //     "message":"Послат вам је мејл за потврду пријаве на ,,newsletter\" Правно-информационог система Републике Србије",
                    //     "status":0
                    // }

                }).catch(function (error) {
                    console.log(error);
                });
            }


        },
        selectOption(id) {
            // console.log(this);
            if (this.subscriptionsIds.includes(id)) {
                axios.get(this.baseApiUrl + 'Prins/Unsubscribe/' + id).then(response => {
                    console.log(response);
                }).catch(function (error) {
                    console.log(error);
                });
            } else {
                axios.get(this.baseApiUrl + 'Prins/Subscribe/' + id).then(response => {
                    console.log(response);
                }).catch(function (error) {
                    console.log(error);
                });
            }

            console.log(id);

        },
        fetchFilterData() {
            axios.get(this.baseApiUrl + 'Prins/GetCategoriesForPrins')
                .then(response => {              
                    this.available = response.data.available;
                    this.unavailable = response.data.unavailable;
                    this.subscriptions = response.data.subscriptions;
                    this.guest = response.data.guest;

                    this.categoryIds = this.available.concat(this.unavailable);

                    if (response.data.subscriptions) {
                        for (let i = 0; i < this.subscriptions.length; i++) {
                            this.subscriptionsIds.push(this.subscriptions[i].id);
                            // this.subscriptionsIds2.push(this.subscriptions[i].id);
                        }
                    }

                });
        },
    },
    mounted() {
        this.fetchFilterData();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style scoped></style>
